var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1154 7H11.8846C8.91231 7 6.5 9.41231 6.5 12.3846V29.6154C6.5 32.5877 8.91231 35 11.8846 35H24.4631C25.899 35 27.2487 34.44 28.2682 33.4205L32.9205 28.7682C33.94 27.7487 34.5 26.399 34.5 24.9631V12.3846C34.5 9.41231 32.0877 7 29.1154 7ZM8.65385 29.6154V12.3846C8.65385 10.6041 10.1041 9.15385 11.8846 9.15385H29.1154C30.8959 9.15385 32.3462 10.6041 32.3462 12.3846V24.3026C32.2313 24.2595 32.1164 24.2308 31.9872 24.2308H27.6795C25.4969 24.2308 23.7308 25.9969 23.7308 28.1795V32.4872C23.7308 32.6164 23.7595 32.7313 23.8026 32.8462H11.8846C10.1041 32.8462 8.65385 31.3959 8.65385 29.6154ZM26.7462 31.8985C26.4877 32.1569 26.2005 32.3436 25.8846 32.5015V28.1795C25.8846 27.1887 26.6887 26.3846 27.6795 26.3846H32.0015C31.8436 26.7005 31.6569 26.9877 31.3985 27.2462L26.7462 31.8985Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3201 17.7692H27.6791C28.2678 17.7692 28.756 17.281 28.756 16.6923C28.756 16.1036 28.2678 15.6154 27.6791 15.6154H13.3201C12.7314 15.6154 12.2432 16.1036 12.2432 16.6923C12.2432 17.281 12.7314 17.7692 13.3201 17.7692Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4996 24.2307H13.3201C12.7314 24.2307 12.2432 24.7189 12.2432 25.3076C12.2432 25.8964 12.7314 26.3846 13.3201 26.3846H20.4996C21.0883 26.3846 21.5765 25.8964 21.5765 25.3076C21.5765 24.7189 21.0883 24.2307 20.4996 24.2307Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.0ab858a1.svg";
export { ForwardRef as ReactComponent };